import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';

import closeIcon from '../assets/images/cross-close.svg';
import { clearBookAbleUntil, setBookAbleUntil } from '../features/BookAbleUntilSlice';
import { useEffect } from 'react';
import { variables } from '../Variables';
import { clearScheduleTimeSlotDetail, setScheduleTimeSlotDetail } from '../features/ScheduleTimeSlotDetailSlice';

export const ScheduleTimeSlot = ({ handleClose, callBackClickHandlerNext, backButtonClickHandler, setDuplicateSlotWithSpecificeDate }) => {
    const [bookAbleUnitVal, setBookAbleUnitVal] = useState("");
    const [bookAbleUnitLbl, setBookAbleUnitLbl] = useState("");
    const [suitableSlotOpt, setSuitableSlotOpt] = useState(true);
    const [duplicateSlotDropdownShow, setDuplicateSlotDropdownShow] = useState(true);
    const [duplicateEachSlotDropDown, setDuplicateEachSlotDropDown] = useState("1");
    
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxBookableUntil = useSelector(state => state.bookAbleUntil.bookAbleUntil);
    const user = useSelector(state => state.user.user);
    const reduxProperty = useSelector(state => state.selectedProperty.selectedProperty);
    const reduxScheduleTimeSlotsDetail = useSelector(state => state.scheduleTimeSlotsDetail.scheduleTimeSlotsDetail);
    const dispatch = useDispatch();

    const handlerBookAbleUnitVal = (e) => {
        const value = e.target.value;
        setBookAbleUnitVal(value);
    }

    const handlerBookAbleUnitSelectLbl = (e) => {
        const value = e.target.value;
        setBookAbleUnitLbl(value);
        if (value === "") {
            setBookAbleUnitVal("");
        }
    }

    const handleSuitAbleSlotOpt = (e) => {
        const value = e.target.value === "true";
        setSuitableSlotOpt(value);
        setDuplicateSlotWithSpecificeDate(value);
    }

    const handleDuplicateSlotDropdownShow = (e) => {
        const value = e.target.value === "true";
        setDuplicateSlotDropdownShow(value);
        if (value == false) {
            setDuplicateEachSlotDropDown("1");
        }
    }

    const handleClickNext = () => {
        if (bookAbleUnitVal && bookAbleUnitLbl) {
            let bookAbleUntilObj = {
                label: bookAbleUnitVal != "" ? bookAbleUnitLbl : null,
                value: bookAbleUnitVal != "" ? bookAbleUnitVal : null
            }
        /*    console.log(bookAbleUntilObj);*/
            dispatch(setBookAbleUntil(bookAbleUntilObj));
        }

        const scheduleTimeSlotsDetailObj = {
            duplicateDropdownOption: duplicateSlotDropdownShow,
            duplicateSpecificeDateSuitAbleOption: suitableSlotOpt,
            duplicateEachSlotDropdown: duplicateEachSlotDropDown
        }

        dispatch(setScheduleTimeSlotDetail(scheduleTimeSlotsDetailObj));
        callBackClickHandlerNext();
    }

    const handleClickBack = () => {
        dispatch(clearScheduleTimeSlotDetail(null));
        dispatch(clearBookAbleUntil(null));
        backButtonClickHandler();
    }

    const onChangeDuplicateEachSlotDropdown = (e) => {
        const value = e.target.value;
        setDuplicateEachSlotDropDown(value);
    }

    const getEstateConfigurationsFromDb = async () => {

        const url = variables.API_URL + `Calendar/GetEstateConfigurations?clientId=${user.user.clientId}&estateId=${reduxProperty.id}`;

        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };

        await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                let _estateConfig = response.data;
                if (_estateConfig != null && _estateConfig.bookableUntilType && _estateConfig.bookableUntilValue) {
                    console.log(_estateConfig);
                    setBookAbleUnitLbl(_estateConfig.bookableUntilType);
                    setBookAbleUnitVal(_estateConfig.bookableUntilValue);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    useEffect(() => {
        /*console.log(reduxBookableUntil);*/
        if (reduxBookableUntil == null) {
            getEstateConfigurationsFromDb();
        }
        else {
            setBookAbleUnitLbl(reduxBookableUntil.label);
            setBookAbleUnitVal(reduxBookableUntil.value);
        }

        if (reduxScheduleTimeSlotsDetail != null) {
            setDuplicateSlotDropdownShow(reduxScheduleTimeSlotsDetail.duplicateDropdownOption);
            setSuitableSlotOpt(reduxScheduleTimeSlotsDetail.duplicateSpecificeDateSuitAbleOption);
            setDuplicateEachSlotDropDown(reduxScheduleTimeSlotsDetail.duplicateEachSlotDropdown);
            setDuplicateSlotWithSpecificeDate(reduxScheduleTimeSlotsDetail.duplicateSpecificeDateSuitAbleOption);
        } else {
            setDuplicateSlotWithSpecificeDate(suitableSlotOpt);
        }

    }, [])

    return (
        <>
            <div className="d-flex justify-content-between mb-3">
                <ul className="form-steps">
                    <li className="step-bar active"></li>
                    <li className="step-bar"></li>
                    <li className="step-bar"></li>
                    <li className="step-bar"></li>
                </ul>
                <img src={closeIcon} onClick={handleClose} className="cursor-pointer" />
            </div>

            <div>
                <p className="form-title mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["scheduleTimeSlotTitlel"] : "Schedule Time Slots"}</p>
                <p className="subtitle mb-4">{reduxLanguageTranslations ? reduxLanguageTranslations["scheduleTimeSlotSubTitlel"] : "Slot creation options"}</p>
            </div>
            <div className="mb-4">
                <label className="form-group-label mt-0">{reduxLanguageTranslations ? reduxLanguageTranslations["suitableSlotLabel"] : "Define your suitable option"}</label>
                <label className="modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-100 line-height-0 mb-2" htmlFor={`radio1`}>
                    <input className="custom-radio me-2" type="radio" name={`radioBtnSuitableSlotDuplicate`} id={`radio1`} value="true" checked={suitableSlotOpt === true} onChange={handleSuitAbleSlotOpt} />
                    {reduxLanguageTranslations ? reduxLanguageTranslations["SpecifcDateRadioBtnTxt"] : "Specific dates"}
                </label>
                <label className="modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-100 line-height-0" htmlFor={`radio2`}>
                    <input className="custom-radio me-2" type="radio" name={`radioBtnSuitableSlotDuplicate`} id={`radio2`} value="false" checked={suitableSlotOpt === false} onChange={handleSuitAbleSlotOpt} />
                    {reduxLanguageTranslations ? reduxLanguageTranslations["WeeklyRecurrencesRadioBtnTxt"] : "Weekly recurrences"}
                </label>
            </div>
            <div>
                <p className="subtitle mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["DuplicateEachSlotLabel"] : "Duplicate each slot:"}</p>
                <p className="mb-4">{reduxLanguageTranslations ? reduxLanguageTranslations["DuplicateEachSlotSubLabel"] : "Each time slot will be created multiple times, allowing multiple independent booking at the same time."}</p>
                <div className="d-flex align-items-center mb-4">
                    <div className="d-flex w-50">
                        <div className="d-flex align-items-center me-3">
                            <input className="custom-radio me-2" type="radio" name={`radioBtnDuplicateDropdownNo`} id={`radioYes`} value="true" checked={duplicateSlotDropdownShow === true} onChange={handleDuplicateSlotDropdownShow} />
                            <label class="modal-p-text-black" for="radioYes">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["quesSummaryModalAnsRadioOptionYes"] : "Yes"}
                            </label>
                        </div>
                        <div className="d-flex align-items-center">
                            <input className="custom-radio me-2" type="radio" name={`radioBtnDuplicateDropdownNo`} id={`radioNo`} value="false" checked={duplicateSlotDropdownShow === false} onChange={handleDuplicateSlotDropdownShow} />
                            <label class="modal-p-text-black" for="radioNo">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["quesSummaryModalAnsRadioOptionNo"] : "No"}
                            </label>
                        </div>
                    </div>
                    <div className={`w-50 ${duplicateSlotDropdownShow ? "d-block" : "d-none"}`}>
                        <select className="form-select" id="slotDuplicationNoDropdown" value={duplicateEachSlotDropDown} onChange={onChangeDuplicateEachSlotDropdown} >
                            <option value="1">1 time</option>
                            <option value="2">2 time</option>
                            <option value="3">3 time</option>
                            <option value="4">4 time</option>
                            <option value="5">5 time</option>
                            <option value="6">6 time</option>
                            <option value="7">7 time</option>
                            <option value="8">8 time</option>
                            <option value="9">9 time</option>
                            <option value="10">10 time</option>
                        </select>
                    </div>
                </div>
                <p className="subtitle mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["DeadlineBookingBeforeStartSlotLabel"] : "Deadline for booking before the start of the slot"}</p>
                <div className="d-flex justify-content-between align-items-center w-50">
                    <input className={`form-control no-spinner me-2 ${bookAbleUnitLbl != "" && bookAbleUnitLbl != null ? "d-blcok" : "d-none"} `} type="number" value={bookAbleUnitVal} onChange={handlerBookAbleUnitVal} />
                    <select className="form-select" value={bookAbleUnitLbl} onChange={handlerBookAbleUnitSelectLbl}>
                        <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageSelectOpt"] : "Select Option"}</option>
                        <option value="days">{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalBookAbleUnitDaysOpt"] : "Days"}</option>
                        <option value="hours">{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalBookAbleUnitHoursOpt"] : "Hours"}</option>
                    </select>
                </div>
            </div>

            <div className="d-flex mt-4">
                <button type="button" className="filter-btn site-btn-padd border-dark color-dark w-100 me-3" onClick={handleClickBack}>{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalBackBtn"] : "Back"}</button>
                <button type="button" className="site-btn site-btn-padd w-100" onClick={handleClickNext}>{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalNextBtn"] : "Next"}</button>
            </div>
        </>
    )
}